// src/components/Hero.js

import React from "react";
import { Container, Typography, Button, Box } from "@mui/material";

function Hero() {
  return (
    <Box
      sx={{
        backgroundImage: `url('/path/to/your/background-image.jpg')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        textAlign: "center",
        px: { xs: 2, sm: 4 },
        py: { xs: 6, sm: 4 },
        overflow: "hidden", // Evita redimensionamiento innecesario
      }}>
      <Container maxWidth="md" sx={{ overflow: "hidden" }}>
        {/* <Typography variant="h2" component="h1" gutterBottom>
          Bienvenid@
        </Typography> */}
        <img
          src="imagenes/logo_completo.png"
          alt="logo"
          style={{
            width: "min(100%, 400px)",
            height: "auto",
            filter: "brightness(0) saturate(100%) invert(1)",
          }}
        />
        <Typography
          variant="h5"
          component="p"
          gutterBottom
          sx={{ fontSize: { xs: "1.15rem", sm: "1.5rem" }, px: { xs: 1, sm: 0 } }}
        >
          Servicios de desarrollo web a medida, optimización SEO y más.
        </Typography>
        <Button
          variant="contained"
          color="secondary"
          size="large"
          href="#contact"
          sx={{ mt: 3 }}>
          Contáctanos
        </Button>
      </Container>
    </Box>
  );
}

export default Hero;
